"use strict";
/* eslint-disable functional/no-expression-statement */
/* eslint-disable functional/no-return-void */
/* eslint-disable functional/functional-parameters */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapRouter = exports.defaultSettings = void 0;
var oaf_routing_1 = require("oaf-routing");
var rxjs_1 = require("rxjs");
exports.defaultSettings = __assign({}, oaf_routing_1.defaultSettings);
var wrapRouter = function (router, settingsOverrides) {
    var settings = __assign(__assign({}, exports.defaultSettings), settingsOverrides);
    var oafRouter = (0, oaf_routing_1.createOafRouter)(settings, function (location) { return location.hash; });
    var initialState = router.state;
    // TODO: fold this into the RxJS observable below.
    // HACK: We use setTimeout to give React a chance to render before we repair focus.
    setTimeout(function () {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        oafRouter.handleFirstPageLoad(initialState.location);
    }, settings.renderTimeout);
    /**
     * The Typescript type of `fromEventPattern` is... not good.
     *
     * The implementation below _could_ simplify down to the following:
     *
     * ```
     * fromEventPattern<RouterState>(
     *   (handler) => router.subscribe(handler),
     *   (_, unsubscribe: () => void) => unsubscribe(),
     * )
     * ```
     *
     * but then we would be vulnerable to changes that affect either the `RouterState` type or the `() => void` type.
     * Those could change and we wouldn't know about it, because `fromEventPattern` doesn't attempt to derive those
     * types from its parameters, instead just resorting to `any`. By specifying the types we are in effect performing an (unsafe)
     * type assertion.
     *
     * To make the type assertion safer, we use the `Parameters` and `ReturnType` helpers to derive the types
     * from the type of the router parameter directly. The result is the same, but instead of being entirely decoupled from the actual
     * types defined by the `Router` type, we will pick up any changes.
     *
     * The tradeoff is that it's uglier and more verbose, but in exchange we get much more type safety.
     *
     * The real solution would be to fix the `any` typings in `fromEventPattern` upstream.
     */
    var routerObservable = function (router) {
        return (0, rxjs_1.fromEventPattern)(function (handler) { return router.subscribe(handler); }, function (_, unsubscribe) {
            return unsubscribe();
        });
    };
    // TODO: push this RxJS pipeline down into oaf-router and have consumer libs like oaf-react-router
    // be responsible only for creating and passing in the routerObservable?
    var subscription = routerObservable(router)
        .pipe(
    // Filter submitted and loading navigation events. We don't want to repair focus, announce navigation or restore scroll/focus
    // until navigation has settled back to the idle state again. See https://reactrouter.com/en/main/hooks/use-navigation#navigationstate
    (0, rxjs_1.filter)(function (state) { return state.navigation.state === "idle"; }), (0, rxjs_1.scan)(function (acc, nextState) { return ({
        previousState: acc.state,
        state: nextState,
    }); }, { state: initialState }), (0, rxjs_1.tap)(function (_a) {
        var previousState = _a.previousState, state = _a.state;
        // We're the first subscribed listener, so the DOM won't have been updated yet.
        return oafRouter.handleLocationWillChange(previousState.location.key, state.location.key, state.historyAction);
    }), 
    // HACK: Give React a chance to render before we repair focus.
    // TODO: This will likely fall apart with suspense / async rendering.
    // At that point, we may have to tap into React (and React Router) more directly. Thus far, the trade-off
    // made by oaf-router has been to do everything via the DOM directly and remain framework agnostic.
    // That has maximized its reusability (check out https://github.com/oaf-project/oaf-routing#libraries-that-use-oaf-routing)
    // at the cost of not being able to intimately tie into specific framework / router life cycles.
    // When frameworks and routers are simple, we can get away with the delay/setTimeout hack. But if they're not...
    (0, rxjs_1.delay)(settings.renderTimeout), (0, rxjs_1.concatMap)(function (_a) {
        var previousState = _a.previousState, state = _a.state;
        return (0, rxjs_1.defer)(function () {
            return oafRouter.handleLocationChanged(previousState.location, state.location, state.location.key, state.historyAction);
        });
    }))
        .subscribe();
    return function () {
        oafRouter.resetAutoScrollRestoration();
        subscription.unsubscribe();
    };
};
exports.wrapRouter = wrapRouter;
